import React from 'react';
import { FormControl, FormGroup, Row, Col, Button, Glyphicon, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { uniqueId } from '../helpers';
import fuzzyFilterFactory from 'react-fuzzy-filter';
const {InputFilter, FilterResults} = fuzzyFilterFactory();

// Add a second filter
const fuzzyFilterFactoryTwo = fuzzyFilterFactory();
const InputFilterTwo = fuzzyFilterFactoryTwo.InputFilter;
const FilterResultsTwo = fuzzyFilterFactoryTwo.FilterResults;

class MultipleSelect extends React.Component {
  constructor(props) {
    super(props);
    this.highlightAvailable = this.highlightAvailable.bind(this);
    this.highlightSelected = this.highlightSelected.bind(this);
    this.moveToSelected = this.moveToSelected.bind(this);
    this.moveToAvailable = this.moveToAvailable.bind(this);
    this.state = {
      available: this.props.available,
      selected: this.props.selected,
      availableValues: [],
      selectedValues: [],
    };
  }

  componentDidMount() {
    this.screenReaderContent.focus();
  }

  componentWillReceiveProps(nextProps) {
    const propsChanged = this.props.available !== nextProps.available || this.props.selected !== nextProps.selected;

    if (propsChanged) {
      this.setState({
        available: nextProps.available,
        selected: nextProps.selected
      });
    }
  }

  highlightAvailable(e) {
    const highlightedValues = [...e.target.options].filter(o => o.selected).map(o => o.value);
    this.setState({ availableValues: highlightedValues });
  }

  moveToSelected() {
    const itemsToMove = [];
    const itemsToKeep = [];

    this.state.available.forEach(item => {
      const isHighlighted = this.state.availableValues.includes(item.id.toString());
      isHighlighted ? itemsToMove.push(item) : itemsToKeep.push(item);
    });

    // Add items on both sides
    this.setState({selected: [...this.state.selected, ...itemsToMove] })
    this.setState({available: itemsToKeep});
  }


  highlightSelected(e) {
    const highlightedValues = [...e.target.options].filter(o => o.selected).map(o => o.value);
    this.setState({ selectedValues: highlightedValues });
  }

  moveToAvailable() {
    const itemsToMove = [];
    const itemsToKeep = [];

    this.state.selected.forEach(item => {
      const isHighlighted = this.state.selectedValues.includes(item.id.toString());
      isHighlighted ? itemsToMove.push(item) : itemsToKeep.push(item);
    });

    // Add items on both sides
    this.setState({available: [...this.state.available, ...itemsToMove] })
    this.setState({selected: itemsToKeep});
  }

  tooltip = name => {
    const id = uniqueId();
    return (
      <Tooltip
        id={id}
        placement="left"
      >
        {name}
      </Tooltip>
    )
  }

  render() {
    return (
      <Row>
        <h3
          className="screen-reader-only"
          tabIndex="-1"
          ref={i => this.screenReaderContent = i}
        >
          Showing insights for insight set {this.props.currentInsightSet.name}
        </h3>
        <Col xs={12} sm={5}>
          <FormGroup>
            <h4>Available</h4>
            <div className="filter-box">
              <InputFilter inputProps={{
                className: 'form-control',
                placeholder: 'Filter'
              }} />
              <Button type="submit" className="search"><Glyphicon glyph="search" /></Button>
            </div>
          </FormGroup>
          <FormGroup>
            <FilterResults
              items={this.state.available}
              fuseConfig={{
                keys: ['id', 'name'],
                threshold: 0.3 // 0.0 is perfect match. 1.0 matches anything
              }}>
              { filteredItems => {
                return (
                  <FormControl
                    componentClass="select"
                    multiple
                    size={10}
                    onChange={this.highlightAvailable}
                    defaultValue={this.state.availableValues}
                    aria-label="Available Insight Sets"
                  >
                    {filteredItems.map((item) =>
                      <OverlayTrigger
                        key={item.id}
                        placement="left"
                        overlay={this.tooltip(item.name)}
                        delay={1000}
                      >
                        <option
                          value={item.id}
                        >
                          {item.name}
                        </option>
                      </OverlayTrigger>
                    )}
                  </FormControl>
                )}
              }
            </FilterResults>
          </FormGroup>
        </Col>

        <Col xs={12} sm={2} className="multi-select-buttons">
          <Button onClick={this.moveToSelected} className="relative-padding" aria-label="Add Insight to Insight Set">
            Add &gt;
          </Button>
          <Button onClick={this.moveToAvailable} className="relative-padding" aria-label="Remove Insight from Insight Set">
            &lt; Remove
          </Button>
        </Col>

        <Col xs={12} sm={5}>
          <FormGroup>
            <h4>Selected</h4>
            <div className="filter-box">
              <InputFilterTwo inputProps={{
                className: 'form-control',
                placeholder: 'Filter'
              }} />
              <Button type="submit" className="search"><Glyphicon glyph="search" /></Button>
            </div>
          </FormGroup>
          <FormGroup>
            <FilterResultsTwo
              items={this.state.selected}
              fuseConfig={{
                keys: ['id', 'name'],
                threshold: 0.3 // 0.0 is perfect match. 1.0 matches anything
              }}>
              { filteredItems => {
                return (
                  <FormControl
                    componentClass="select"
                    multiple
                    size={10}
                    onChange={this.highlightSelected}
                    defaultValue={this.state.selectedValues}
                    aria-label="Already assigned Insight Sets"
                  >
                    {filteredItems.map((item) =>
                      <OverlayTrigger
                        key={item.id}
                        placement="left"
                        overlay={this.tooltip(item.name)}
                        delay={1000}
                      >
                        <option value={item.id}>
                          {item.name}
                        </option>
                      </OverlayTrigger>
                    )}
                  </FormControl>
                )}
              }
            </FilterResultsTwo>
          </FormGroup>
        </Col>

        <Col sm={12} className="table-header form-group">
          <Button
            bsStyle="primary"
            className="relative-padding"
            onClick={() => this.props.onSubmit(this.state.selected, this.state.available) }
          >
            Save
          </Button>
        </Col>
        <br/>
      </Row>
    )
  }
}

export default MultipleSelect;



// WEBPACK FOOTER //
// ./src/components/MultipleSelect.js